import PropTypes from "prop-types";
import React from "react";

export const Lavatory = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path d="M5.5 22V14.5H4V9C4 8.45 4.19583 7.97917 4.5875 7.5875C4.97917 7.19583 5.45 7 6 7H9C9.55 7 10.0208 7.19583 10.4125 7.5875C10.8042 7.97917 11 8.45 11 9V14.5H9.5V22H5.5ZM7.5 6C6.95 6 6.47917 5.80417 6.0875 5.4125C5.69583 5.02083 5.5 4.55 5.5 4C5.5 3.45 5.69583 2.97917 6.0875 2.5875C6.47917 2.19583 6.95 2 7.5 2C8.05 2 8.52083 2.19583 8.9125 2.5875C9.30417 2.97917 9.5 3.45 9.5 4C9.5 4.55 9.30417 5.02083 8.9125 5.4125C8.52083 5.80417 8.05 6 7.5 6ZM15 22V16H12L14.55 8.35C14.6833 7.91667 14.9292 7.58333 15.2875 7.35C15.6458 7.11667 16.05 7 16.5 7C16.95 7 17.3542 7.11667 17.7125 7.35C18.0708 7.58333 18.3167 7.91667 18.45 8.35L21 16H18V22H15ZM16.5 6C15.95 6 15.4792 5.80417 15.0875 5.4125C14.6958 5.02083 14.5 4.55 14.5 4C14.5 3.45 14.6958 2.97917 15.0875 2.5875C15.4792 2.19583 15.95 2 16.5 2C17.05 2 17.5208 2.19583 17.9125 2.5875C18.3042 2.97917 18.5 3.45 18.5 4C18.5 4.55 18.3042 5.02083 17.9125 5.4125C17.5208 5.80417 17.05 6 16.5 6Z" />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      strokeWidth: "0",
      style,
      viewBox: "0 0 24 24",
    };
  }
};

Lavatory.displayName = "LavatoryIcon";

Lavatory.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

Lavatory.defaultProps = { role: "img" };
